<ambita-multiple-report class="ambita-multiple-report">
  <ambita-report-print-toolbar/>
  <report-header/>

  <script>
    import '../common/reportHeader.tag';
    import '../reportPrintToolbar/reportPrintToolbar.tag';
    import './multipleReport.scss';
    import { init } from './multipleReportController';

    init(this);
  </script>
</ambita-multiple-report>
